/** Reading (never trusting) the access token client-side, to know when to refresh. */

type JwtPayload = { exp?: number };

/**
 * Decode a JWT payload without verifying it. Safe because the result is only
 * used to decide when to refresh; the server is the only thing that validates.
 */
export function readJwtPayload(token: string): JwtPayload | null {
  const payload = token.split(".")[1];
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64)) as JwtPayload;
  } catch {
    return null;
  }
}

/**
 * True when the token is expired, or close enough that a request made now could
 * arrive after it expires. Unreadable tokens return false: let the server
 * reject them rather than looping on refresh.
 */
export function expiresWithin(token: string, seconds: number): boolean {
  const payload = readJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;
  return payload.exp * 1000 - Date.now() < seconds * 1000;
}
